
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VueJSModal from 'vue-js-modal'
import eventBus from '../../plugins/eventBus'
import { addToCartSuccess } from '@/plugins/popups'
import { ItemModel } from '@/store/models/ItemModel'
import { OrderDetailModel } from '@/store/models/OrderDetailModel'
import { FavoritesStore } from '@/store/stores/FavoritesStore'
import { envConfiguration } from '@/plugins/globalStaticDatas'

Vue.use(VueJSModal)

@Component({})
export default class OrderModal extends Vue {
  @Prop()
  details: any
  @Prop()
  orderNo: any
  orderDetails: OrderDetailModel[] = []
  favorites: FavoritesStore = FavoritesStore.getInstance()
  envConfigurations: any = envConfiguration

  @Watch('details')
  onPropertyChanged() {
    this.favorites.loadData()
    this.orderDetails = this.details.map((detail: OrderDetailModel) => {
      Object.assign(detail.product, {
        isFavorite: this.isProductFavorite(detail.product),
      })
      return detail
    })
  }

  closeModal() {
    this.$modal.hide('order-details')
  }

  addToCart(product: Object) {
    eventBus.$emit('cart:item-added', product)
    addToCartSuccess()
  }

  isProductFavorite(product: ItemModel) {
    const productExists = (obj: any) => obj.id === product.id
    return this.favorites.getStore().some(productExists)
  }

  mounted() {
    this.favorites.loadData()
  }
}
